import { render, staticRenderFns } from "./Initiative.vue?vue&type=template&id=aeb1e614&scoped=true&"
var script = {}
import style0 from "./Initiative.vue?vue&type=style&index=0&id=aeb1e614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb1e614",
  null
  
)

export default component.exports